export default "__VITE_ASSET__xYakvQLl__"